import { React, useEffect, useState, Fragment,useContext } from "react";
import { Grid as GridKendo, GridColumn as Column } from "@progress/kendo-react-grid";
import { Grid} from '@mui/material';
import * as fairService from "../api/api";
import * as countryService from "../../Country/api/api"
import * as cityService from "../../City/api/api"

import MyCard from '../../../shared/components/myCard'
import CircularProgress from '@mui/material/CircularProgress';
import { toast } from "react-toastify";



import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import Page from '../../../components/Page';
// Material UI
import { Box, Button, MenuItem, Select, TextField } from '@mui/material';
import * as languageService from "../../Language/api/api"
import * as userService from "../../User/api/api"
import { getValue } from "@testing-library/user-event/dist/utils";
import LocalStorageService from "../../../shared/services/localStorageService";

import { AuthContext } from "src/Auth/components/AuthContext";



function ChangePassword() {
  const {
    authUser
  } = useContext(AuthContext);

var userId = authUser.userId;  

    const [oldPassword, setOldPassword] = useState("");
    const [newPassword, setNewPassword] = useState("");
    const [cancelUpdate, setCancelUpdate] = useState(false);
 
    
    const defaultInputValues = {
      oldPassword: "",
      newPassword: ""
    };

    const validationSchema = Yup.object().shape({
      oldPassword: Yup.string().required('Eski şifre girilmesi zorunlu alan!'),
      newPassword: Yup.string().required('Yeni şifre girilmesi zorunlu alan!')
    });


    const {
        register,
        handleSubmit,
        formState: { errors },
        setValue,
        getValues,
    } = useForm({ defaultValues: defaultInputValues, resolver: yupResolver(validationSchema) });
 
  
 function updateUserPass(){
  const inputModel = {
    "UserId":userId,
    "oldPassword": getValues("oldPassword"),
    "newPassword": getValues("newPassword")
     
  }
  userService.changePassword(inputModel).then(function(res){
    const { isSuccess, message, data: countriesData } = res;
    if (isSuccess ) {
      toast.success("Şifreniz başarıyla değiştirildi")
    } else {
      toast.error("HATA - " + message);
      console.log(res, "changePassword-hata");
    }
    


  });
 }



  return (
    <Page title="Şifre Değiştir">
      <Fragment>
        <MyCard header="Şifre Değiştir">
         
          <Grid container xs={4}  spacing={2}>
 
            <Grid item xs={12}>
              <TextField InputLabelProps={{ shrink: true }}
                fullWidth
                required
                id="outlined-required"
                label="Eski şifreniz"
                error={errors.oldPassword ? true : false}
                helperText={errors.oldPassword?.message}
                {...register("oldPassword")}
                size="small"
              />
            </Grid>

            <Grid item  xs={12} >
              <TextField InputLabelProps={{ shrink: true }}
                fullWidth
                required
                label="Yeni şifreniz"
                error={errors.newPassword ? true : false}
                helperText={errors.newPassword?.message}
                {...register("newPassword")}
                size="small"
              />
            </Grid>
            




            <Grid container spacing={2} padding={2}
  direction="row"
 > <Grid item >
              <Button
                 onClick={handleSubmit(updateUserPass)}
                variant="contained"
                fullWidth
              >
                Kaydet
              </Button>
              
              </Grid>
           


            </Grid>
           
          </Grid>
        </MyCard>
      </Fragment>
     
    </Page>
  );
}

export default ChangePassword;
